import JourneyTouchpoint from './JourneyTouchpoint';
import JourneyTouchpointIcon from './JourneyTouchpointIcon';
import JourneyStage from './JourneyStage';
import JourneyNarrative from './JourneyNarrative';
import ExperienceScore from './ExperienceScore';
export default {
  JourneyTouchpoint: JourneyTouchpoint,
  JourneyTouchpointIcon: JourneyTouchpointIcon,
  JourneyStage: JourneyStage,
  JourneyNarrative: JourneyNarrative,
  ExperienceScore: ExperienceScore
};